export var EDrivingMarketSectionType;
(function (EDrivingMarketSectionType) {
    EDrivingMarketSectionType["GAIN"] = "gain";
    EDrivingMarketSectionType["LOSS"] = "loss";
    EDrivingMarketSectionType["HIGHOIGAINER"] = "highOiGainer";
    EDrivingMarketSectionType["HIGHOILOSER"] = "highOiLoser";
    EDrivingMarketSectionType["ACTIVEVOLUME"] = "activeVolume";
    EDrivingMarketSectionType["ACTIVEVALUVE"] = "activeValue";
    EDrivingMarketSectionType["HIGHROLLOVER"] = "highRollover";
    EDrivingMarketSectionType["LOWROLLOVER"] = "lowRollover";
    EDrivingMarketSectionType["HIGHPREMIUM"] = "highPremium";
    EDrivingMarketSectionType["HIGHDISCOUNT"] = "highDiscount";
})(EDrivingMarketSectionType || (EDrivingMarketSectionType = {}));
export var DrivingMarketMsgIcon;
(function (DrivingMarketMsgIcon) {
    DrivingMarketMsgIcon["LIMIT"] = "edel-icon-likes1";
    DrivingMarketMsgIcon["DEFAULT"] = "";
})(DrivingMarketMsgIcon || (DrivingMarketMsgIcon = {}));
export const drivingMarketLimit = 5;
